<template>
  <div>
    <div v-for="(item, index) in modelObjects" :key="index">
      <ValidationObserver>
        <v-form>
          <v-layout>

            <v-flex xs12>
              <ValidationProvider name="compétence" rules="max:128">
                <v-text-field
                  slot-scope="{
                              errors,
                              valid
                              }"
                  :error-messages="errors"
                  :success="valid"
                  label="Compétence:"
                  v-model="item.title"
                  v-on:blur="updateModelObject(item.id, item)"
                >
                </v-text-field>
              </ValidationProvider>
            </v-flex>

            <v-flex xs12>
              <ValidationProvider name="niveau" rules="numeric">
                <v-rating
                  slot-scope="{
                              errors,
                              valid
                              }"
                  :error-messages="errors"
                  :success="valid"
                  v-model="item.rating"
                  @input="updateModelObject(item.id, item)"
                >
                </v-rating>
              </ValidationProvider>
            </v-flex>

            <v-flex pb-1 class="text-xs-right">
              <v-btn icon flat small color="red" class="pa-0 ma-0"
                v-on:click.stop="deleteModelObject(item.id, index)"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>

          </v-layout>
        </v-form>
      </ValidationObserver>
    </div>
    <v-spacer></v-spacer>
    <div>
      <v-btn outline round color="info" v-on:click="addModelObject();">
        <v-icon left>add_circle_outline</v-icon>
        Ajouter une compétence
      </v-btn>
    </div>
  </div>

</template>

<script>
 import {
   ValidationObserver,
   ValidationProvider,
   withValidation
 } from "vee-validate";
 import session from '../api/session';
 import { mixin_ajax } from './mixin_ajax_vue.js';

 export default {
   mixins: [mixin_ajax],
   props: ['skillslist', 'catid', 'cv_id'],
   components: {
     ValidationProvider,
     ValidationObserver
   },
   data: function() {
     return {
       api_url: '/api/' + this.cv_id + '/skill/',

       modelObjects: [],
       newModelObject: function() {
         return {
           'title': '',
           'rating': 0,
           'skillcat': this.catid
         }
       },

     }
   },
   methods: {
     getModelObjects: function() {
       /*
          Prend un paramètre représentant la catégorie de compétences.
          Beaucoup plus performant!
          Voir SkillViewSet viewsets.py pour Django.
        */
       this.isLoading = true;
       // https://flaviocopes.com/axios/#add-parameters-to-get-requests
       session.get(this.api_url, {
         params: {
           category: this.catid
         }
       })
              .then((response) => {
                this.modelObjects = response.data;
                this.isLoading = false;
                console.log('GET CALLED : ' + this.api_url);
                console.log(response)
              })
              .catch((err) => {
                this.isLoading = false;
                if (err.response) {
                  // The request was made and the server responded with a status code
                  // that falls out of the range of 2xx
                  console.log('======= getModelObjects error in response =======')
                  console.log(err.response.data);
                  console.log(err.response.status);
                  console.log(err.response.headers);
                } else if (err.request) {
                  // The request was made but no response was received
                  // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                  // http.ClientRequest in node.js
                  console.log('======= getModelObjects error in request =======')
                  console.log(err.request);
                } else {
                  // Something happened in setting up the request that triggered an Error
                  console.log('======= getModelObjects error in else =======')
                  console.log('Err', err.message);
                }
              })
     },

     testEvent() {
       console.log("CLICKEDDDDDD");
     }
   },

 }

</script>
